<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11.999" height="12" viewBox="0 0 11.999 12">
    <g id="move-left" transform="translate(-0.001)">
      <path
        id="Path_4948"
        data-name="Path 4948"
        d="M11,0a1,1,0,0,0-1,1V11a1,1,0,0,0,2,0V1A1,1,0,0,0,11,0Z"
        fill="#991e66"
      />
      <path
        id="Path_4949"
        data-name="Path 4949"
        d="M4.707,2.045a.5.5,0,0,0-.536.079l-4,3.5a.5.5,0,0,0,0,.752l4,3.5A.5.5,0,0,0,5,9.5V7H7.5A.5.5,0,0,0,8,6.5v-1A.5.5,0,0,0,7.5,5H5V2.5A.5.5,0,0,0,4.707,2.045Z"
        fill="#991e66"
      />
    </g>
  </svg>
</template>
